import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=4f1d4dcb&"
import script from "./DeleteAccount.ts?vue&type=script&lang=ts&"
export * from "./DeleteAccount.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports